/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, markType } from "./type";
import { UIElementPropertyAccessorFactory } from "./UIElementPropertyAccessorFactory";
import { MatrixTransform } from "./MatrixTransform";
import { TransformMatrixHelpler } from "./TransformMatrixHelpler";
/**
 * @hidden
 */
var NativeUI = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(NativeUI, _super);
    function NativeUI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NativeUI.ac = function (a, b, c) {
        var d = UIElementPropertyAccessorFactory.c.a(a);
        d.c(b, c);
    };
    NativeUI.j = function (a, b) {
        var c = UIElementPropertyAccessorFactory.c.a(a);
        return c.b(b);
    };
    NativeUI.u = function (a, b) {
        NativeUI.ac(1, a, b);
    };
    NativeUI.e = function (a) {
        return NativeUI.j(1, a);
    };
    NativeUI.k = function (a, b) {
        NativeUI.ac(2, a, b);
    };
    NativeUI.af = function (a) {
        return NativeUI.j(2, a);
    };
    NativeUI.l = function (a, b) {
        NativeUI.ac(3, a, b);
    };
    NativeUI.ag = function (a) {
        return NativeUI.j(3, a);
    };
    NativeUI.n = function (a, b) {
        NativeUI.ac(4, a, b);
    };
    NativeUI.ak = function (a) {
        return NativeUI.j(4, a);
    };
    NativeUI.m = function (a, b) {
        NativeUI.ac(5, a, b);
    };
    NativeUI.v = function (a, b) {
        NativeUI.ac(6, a, b);
    };
    NativeUI.am = function (a) {
        return NativeUI.j(6, a);
    };
    NativeUI.ae = function (a) {
        return NativeUI.j(5, a);
    };
    NativeUI.o = function (a, b) {
        NativeUI.ac(7, a, b);
    };
    NativeUI.ah = function (a) {
        return NativeUI.j(7, a);
    };
    NativeUI.q = function (a, b) {
        NativeUI.ac(8, a, b);
    };
    NativeUI.b = function (a) {
        return NativeUI.j(8, a);
    };
    NativeUI.ad = function (a, b) {
        NativeUI.ac(9, a, b);
    };
    NativeUI.i = function (a) {
        return NativeUI.j(9, a);
    };
    NativeUI.r = function (a, b) {
        NativeUI.ac(10, a, b);
    };
    NativeUI.c = function (a) {
        return NativeUI.j(10, a);
    };
    NativeUI.s = function (a, b) {
        NativeUI.ac(11, a, b);
    };
    NativeUI.aa = function (a, b) {
        NativeUI.ac(12, a, b);
    };
    NativeUI.d = function (a) {
        return NativeUI.j(11, a);
    };
    NativeUI.h = function (a) {
        return NativeUI.j(12, a);
    };
    NativeUI.t = function (a, b) {
        NativeUI.ac(13, a, b);
    };
    NativeUI.al = function (a) {
        return NativeUI.j(13, a);
    };
    NativeUI.ab = function (a, b) {
        var c = TransformMatrixHelpler.f(b);
        var d = new MatrixTransform();
        d.j = c;
        NativeUI.ac(14, a, d);
    };
    NativeUI.aj = function (a) {
        return NativeUI.j(14, a);
    };
    NativeUI.w = function (a, b) {
        NativeUI.ac(15, a, b);
    };
    NativeUI.p = function (a, b) {
        NativeUI.ac(16, a, b);
    };
    NativeUI.ai = function (a) {
        return NativeUI.j(15, a);
    };
    NativeUI.z = function (a, b) {
        NativeUI.ac(17, a, b);
    };
    NativeUI.g = function (a) {
        return NativeUI.j(17, a);
    };
    NativeUI.x = function (a, b) {
        NativeUI.ac(18, a, b);
    };
    NativeUI.a = function (a) {
        return NativeUI.j(18, a);
    };
    NativeUI.y = function (a, b) {
        NativeUI.ac(19, a, b);
    };
    NativeUI.f = function (a) {
        return NativeUI.j(19, a);
    };
    NativeUI.$t = markType(NativeUI, 'NativeUI');
    return NativeUI;
}(Base));
export { NativeUI };
//# sourceMappingURL=NativeUI.js.map
